import React from 'react';
import {withRouter, Link} from "react-router-dom";
import { connect } from 'react-redux';
import logo from '../assets/img/logo.svg';
import Api from './../api/api';

class AskExpert extends React.Component {

    state={
        email:'',
        name:'',
        phone:'',
        note:'',
        askAnExpertState: false,
    }

    onChangeInput = (e, inputType) => {
        this.setState({[inputType]: e.target.value});
    }

    AskAnExpertSubmit = () => {
        const {email, name , phone, note} = this.state;
        const data ={email, name , phone, note};
        Api.postAskAnExpert(data).then(()=>{
            this.setState({askAnExpertState:true},()=>{
                setTimeout(()=>{
                    this.setState({
                        askAnExpertState:false,
                        email: '',
                        name: '',
                        phone: '',
                        note: ''
                   });
                }, 5000)
            });
        });
    }

    askAnExpertSubmitAlert = () => {
        return(
            <div className="subscribed-alerts ask-expert-alert">
                <div>
                    <img src={logo} alt="logo" />
                    <p>Ask An Expert</p>
                </div>
                <p>Hi {this.state.name}, <br/>
                    We have received a request to ask a Cerafini expert. .
                </p>
                <span>
                    A member of our sales team will soon be in touch with you to confirm your appointment. 
                </span>
            </div>
        )
    }

    render (){
        const {langTxt, langUrl} =this.props;
        const {askAnExpertState} = this.state;
       return (
           <>
                {(askAnExpertState)? this.askAnExpertSubmitAlert() : ''}
                <div className="ask-an-expert">
                    <div className="ask-an-expert-wrapper">
                        <div className="ask-an-expert-title">
                            <h3>Ask a Cerafini Expert</h3>
                            <p>Book an appointment and we will contact you within 48 hours.</p>
                        </div>
                        <div className="ask-an-expert-form">
                            <div className="name">
                                <p className="cursor-pointer" onClick={()=>document.getElementById("name-input").focus()}>Name*</p>
                                <input id="name-input" value={this.state.name} onChange={(e)=>this.onChangeInput(e, 'name')} type="text" />
                            </div>
                            <div className="email">
                                <p className="cursor-pointer" onClick={()=>document.getElementById("ask-email-input").focus()}>Email*</p>
                                <input id="ask-email-input" value={this.state.email} onChange={(e)=>this.onChangeInput(e, 'email')} type="email" />
                            </div>
                            <div className="phone">
                                <p className="cursor-pointer" onClick={()=>document.getElementById("phone-input").focus()}>Phone</p>
                                <input id="phone-input" value={this.state.phone} onChange={(e)=>this.onChangeInput(e, 'phone')} type="tel" />
                            </div>
                            <div className="note">
                                <p className="cursor-pointer" onClick={()=>document.getElementById("note-input").focus()}>Note</p>
                                <textarea id="note-input" className={`${(this.state.note !== "")? "green -bg opacity-bg": "green-bg" }`} onChange={(e)=>this.onChangeInput(e, 'note')}>{this.state.note}</textarea>
                            </div>
                            <div className="btn-wrapper">
                                <input onClick={()=>this.AskAnExpertSubmit()} value="Send" type="submit" className="btn"/>
                            </div>
                        </div>    
                    </div>
                </div>
            </>
       );
    }
}

// what props do i need to get from the state for this component?
const mapStateToProps = (state) => {
    // get the props needed for this component from the state of the store.
    return {
        langTxt: (state.lang && state.lang.text) || 'en',
        langUrl: (state.lang && state.lang.url) || '',
    }
}

// what events will occur that will change the state in this component
const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default withRouter( connect(mapStateToProps, mapDispatchToProps)(AskExpert) );